<link rel="preload" href="https://alcdn.msauth.net/browser/2.13.1/js/msal-browser.min.js" as="script">


<div class="tal-page-container">
  <div class="tal-page-tutorial">
    <tal-tutorial></tal-tutorial>
  </div>
  <div class="tal-page-topbar">
    <tal-topbar-widget></tal-topbar-widget>
  </div>
  <div class="tal-page-content">
    <router-outlet></router-outlet>
  </div>
</div>
